import * as PIXI from "pixi.js";

const DECIMAL_SIZE_RATIO = 0.87;
const DECIMAL_FILL = "#C8C8C8";

export class MoneyText extends PIXI.Container {
  private mainText: PIXI.Text;
  private decimalText: PIXI.Text;
  private tailText: PIXI.Text;
  private mainStyle: PIXI.TextStyle;
  private decimalStyle: PIXI.TextStyle;
  private value = "";

  constructor(text: string, style: PIXI.TextStyle) {
    super();
    const decimalStyle = style.clone();
    decimalStyle.fontSize = Number(style.fontSize) * DECIMAL_SIZE_RATIO;
    decimalStyle.fill = DECIMAL_FILL;
    this.mainStyle = style;
    this.decimalStyle = decimalStyle;

    this.mainText = new PIXI.Text("", style);
    this.decimalText = new PIXI.Text("", decimalStyle);
    this.tailText = new PIXI.Text("", style);
    this.addChild(this.mainText, this.decimalText, this.tailText);
    this.text = text;
  }

  get text(): string {
    return this.value;
  }

  set text(value: string) {
    this.value = value;
    const match = /^(.*\.)(\d+)(\D*)$/.exec(value);
    this.mainText.text = match ? match[1] : value;
    this.decimalText.text = match ? match[2] : "";
    this.tailText.text = match ? match[3] : "";
    this.layout();
  }

  private layout() {
    const mainAscent = PIXI.TextMetrics.measureFont(
      this.mainStyle.toFontString(),
    ).ascent;
    const decimalAscent = PIXI.TextMetrics.measureFont(
      this.decimalStyle.toFontString(),
    ).ascent;
    this.decimalText.position.set(this.mainText.width, mainAscent - decimalAscent);
    this.tailText.position.set(this.decimalText.x + this.decimalText.width, 0);
  }
}
